import React from 'react'

const Blog = () => {
    return (
        <>
            <section>
                <div className="inn-ban">
                    <div className="container">
                        <div className="row">
                            <h1>Blog &amp; Articles</h1>
                            <p>
                                lacinia viverra lectus. Fusce imperdiet ullamcorper metus eu
                                fringilla
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            {/* END */}
            {/* START */}
            <section>
                <div className="blog-main">
                    <div className="container">
                        <div className="row">
                            <div className="inn">
                                <div className="lhs">
                                    <div className="blog-com-tit">
                                        <h2>Latest &amp; Popular</h2>
                                    </div>
                                    {/*BIG POST START*/}
                                    <div className="blog-home-box">
                                        <div className="im">
                                            <img src="images/couples/9.jpg" alt="" loading="lazy" />
                                            <span className="blog-date">22, Jan 2023</span>
                                            <div className="shar-1">
                                                <i className="fa fa-share-alt" aria-hidden="true" />
                                                <ul>
                                                    <li>
                                                        <a href="#!">
                                                            <i className="fa fa-facebook" aria-hidden="true" />
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="#!">
                                                            <i className="fa fa-twitter" aria-hidden="true" />
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="#!">
                                                            <i className="fa fa-whatsapp" aria-hidden="true" />
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <span>
                                                            <i
                                                                className="fa fa-link"
                                                                aria-hidden="true"
                                                                data-toggle="modal"
                                                                data-target="#sharepop"
                                                            />
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="txt">
                                            <span className="blog-cate">Wedding</span>
                                            <span className="blog-cate">Events</span>
                                            <span className="blog-cate">Decoration</span>
                                            <h2>6 Things You Need To Prepare For Your Wedding Day</h2>
                                            <p>
                                                The remote island nation of Kiribati has gone into lockdown
                                                after passengers on the first international...
                                            </p>
                                            <div className="blog-info">
                                                <div className="blog-pro-info">
                                                    <img src="images/user/2.jpg" alt="" loading="lazy" />
                                                    <h5>
                                                        Steefan Ann <span>Author</span>
                                                    </h5>
                                                </div>
                                            </div>
                                            <a href="blog-detail.html" className="fclick" />
                                        </div>
                                    </div>
                                    {/*END BIG POST START*/}
                                    {/*BIG POST START*/}
                                    <div className="blog-home-box">
                                        <div className="im">
                                            <img src="images/couples/10.jpg" alt="" loading="lazy" />
                                            <span className="blog-date">22, Jan 2023</span>
                                            <div className="shar-1">
                                                <i className="fa fa-share-alt" aria-hidden="true" />
                                                <ul>
                                                    <li>
                                                        <a href="#!">
                                                            <i className="fa fa-facebook" aria-hidden="true" />
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="#!">
                                                            <i className="fa fa-twitter" aria-hidden="true" />
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="#!">
                                                            <i className="fa fa-whatsapp" aria-hidden="true" />
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <span>
                                                            <i
                                                                className="fa fa-link"
                                                                aria-hidden="true"
                                                                data-toggle="modal"
                                                                data-target="#sharepop"
                                                            />
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="txt">
                                            <span className="blog-cate">Wedding</span>
                                            <span className="blog-cate">Events</span>
                                            <span className="blog-cate">Decoration</span>
                                            <h2>
                                                Kiribatii goes into first lockdown after Covid flight cases
                                            </h2>
                                            <p>
                                                The remote island nation of Kiribati has gone into lockdown
                                                after passengers on the first international...
                                            </p>
                                            <div className="blog-info">
                                                <div className="blog-pro-info">
                                                    <img src="images/user/5.jpg" alt="" loading="lazy" />
                                                    <h5>
                                                        Steefan Ann <span>Author</span>
                                                    </h5>
                                                </div>
                                            </div>
                                            <a href="blog-detail.html" className="fclick" />
                                        </div>
                                    </div>
                                    {/*END BIG POST START*/}
                                    {/*BIG POST START*/}
                                    <div className="blog-home-box">
                                        <div className="im">
                                            <img src="images/gallery/9.jpg" alt="" loading="lazy" />
                                            <span className="blog-date">22, Jan 2023</span>
                                            <div className="shar-1">
                                                <i className="fa fa-share-alt" aria-hidden="true" />
                                                <ul>
                                                    <li>
                                                        <a href="#!">
                                                            <i className="fa fa-facebook" aria-hidden="true" />
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="#!">
                                                            <i className="fa fa-twitter" aria-hidden="true" />
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="#!">
                                                            <i className="fa fa-whatsapp" aria-hidden="true" />
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <span>
                                                            <i
                                                                className="fa fa-link"
                                                                aria-hidden="true"
                                                                data-toggle="modal"
                                                                data-target="#sharepop"
                                                            />
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="txt">
                                            <span className="blog-cate">Wedding</span>
                                            <span className="blog-cate">Events</span>
                                            <span className="blog-cate">Decoration</span>
                                            <h2>
                                                Kiribatii goes into first lockdown after Covid flight cases
                                            </h2>
                                            <p>
                                                The remote island nation of Kiribati has gone into lockdown
                                                after passengers on the first international...
                                            </p>
                                            <div className="blog-info">
                                                <div className="blog-pro-info">
                                                    <img src="images/user/4.jpg" alt="" loading="lazy" />
                                                    <h5>
                                                        Steefan Ann <span>Author</span>
                                                    </h5>
                                                </div>
                                            </div>
                                            <a href="blog-detail.html" className="fclick" />
                                        </div>
                                    </div>
                                    {/*END BIG POST START*/}
                                    {/*BIG POST START*/}
                                    <div className="blog-home-box">
                                        <div className="im">
                                            <img src="images/gallery/7.jpg" alt="" loading="lazy" />
                                            <span className="blog-date">22, Jan 2023</span>
                                            <div className="shar-1">
                                                <i className="fa fa-share-alt" aria-hidden="true" />
                                                <ul>
                                                    <li>
                                                        <a href="#!">
                                                            <i className="fa fa-facebook" aria-hidden="true" />
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="#!">
                                                            <i className="fa fa-twitter" aria-hidden="true" />
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="#!">
                                                            <i className="fa fa-whatsapp" aria-hidden="true" />
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <span>
                                                            <i
                                                                className="fa fa-link"
                                                                aria-hidden="true"
                                                                data-toggle="modal"
                                                                data-target="#sharepop"
                                                            />
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="txt">
                                            <span className="blog-cate">Wedding</span>
                                            <span className="blog-cate">Events</span>
                                            <span className="blog-cate">Decoration</span>
                                            <h2>
                                                Kiribatii goes into first lockdown after Covid flight cases
                                            </h2>
                                            <p>
                                                The remote island nation of Kiribati has gone into lockdown
                                                after passengers on the first international...
                                            </p>
                                            <div className="blog-info">
                                                <div className="blog-pro-info">
                                                    <img src="images/user/2.jpg" alt="" loading="lazy" />
                                                    <h5>
                                                        Steefan Ann <span>Author</span>
                                                    </h5>
                                                </div>
                                            </div>
                                            <a href="blog-detail.html" className="fclick" />
                                        </div>
                                    </div>
                                    {/*END BIG POST START*/}
                                    <div className="page-nation">
                                        <ul className="pagination pagination-sm">
                                            <li className="page-item">
                                                <a className="page-link" href="#!">
                                                    Previous
                                                </a>
                                            </li>
                                            <li className="page-item active">
                                                <a className="page-link" href="#!">
                                                    1
                                                </a>
                                            </li>
                                            <li className="page-item">
                                                <a className="page-link" href="#!">
                                                    2
                                                </a>
                                            </li>
                                            <li className="page-item">
                                                <a className="page-link" href="#!">
                                                    3
                                                </a>
                                            </li>
                                            <li className="page-item">
                                                <a className="page-link" href="#!">
                                                    Next
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="rhs">
                                    <div className="blog-com-rhs">
                                        {/* SOCIAL MEDIA START*/}
                                        <div className="blog-soci">
                                            <h4>Social media</h4>
                                            <ul>
                                                <li>
                                                    <a target="_blank" href="#!" className="sm-fb-big">
                                                        <b>3k</b> Facebook
                                                    </a>
                                                </li>
                                                <li>
                                                    <a target="_blank" href="#!" className="sm-tw-big">
                                                        <b>10K</b> Twitter
                                                    </a>
                                                </li>
                                                <li>
                                                    <a target="_blank" href="#!" className="sm-li-big">
                                                        <b>1k</b> Linkedin
                                                    </a>
                                                </li>
                                                <li>
                                                    <a target="_blank" href="#!" className="sm-yt-big">
                                                        <b>100K</b> Youtube
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        {/* SOCIAL MEDIA END*/}
                                        {/* ADS START*/}
                                        <div className="blog-rhs-cate">
                                            <h4>Category</h4>
                                            <ul>
                                                <li>
                                                    <a href="#!">
                                                        <span>1</span>
                                                        <b>Wedding Planning</b>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#!">
                                                        <span>2</span>
                                                        <b>Lifestyle</b>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#!">
                                                        <span>3</span>
                                                        <b>Catering services</b>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#!">
                                                        <span>4</span>
                                                        <b>Wedding Decorations</b>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#!">
                                                        <span>5</span>
                                                        <b>Wedding Halls</b>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#!">
                                                        <span>6</span>
                                                        <b>The Ceremony</b>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#!">
                                                        <span>7</span>
                                                        <b>Photography </b>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        {/* ADS END*/}
                                        {/*TOP POSTS*/}
                                        <div className="hot-page2-hom-pre blog-rhs-trends">
                                            <h4>Trending Posts</h4>
                                            <ul>
                                                <li>
                                                    <div className="hot-page2-hom-pre-1">
                                                        <img src="images/couples/8.jpg" alt="" loading="lazy" />
                                                    </div>
                                                    <div className="hot-page2-hom-pre-2">
                                                        <h5>Simply dummy and typesetting</h5>
                                                    </div>
                                                    <a href="blog-detail.html" className="fclick" />
                                                </li>
                                                <li>
                                                    <div className="hot-page2-hom-pre-1">
                                                        <img src="images/couples/4.jpg" alt="" loading="lazy" />
                                                    </div>
                                                    <div className="hot-page2-hom-pre-2">
                                                        <h5>Wedding make a type specimen book</h5>
                                                    </div>
                                                    <a href="blog-detail.html" className="fclick" />
                                                </li>
                                                <li>
                                                    <div className="hot-page2-hom-pre-1">
                                                        <img src="images/couples/9.jpg" alt="" loading="lazy" />
                                                    </div>
                                                    <div className="hot-page2-hom-pre-2">
                                                        <h5>Halls Letraset sheets containing</h5>
                                                    </div>
                                                    <a href="blog-detail.html" className="fclick" />
                                                </li>
                                                <li>
                                                    <div className="hot-page2-hom-pre-1">
                                                        <img src="images/couples/6.jpg" alt="" loading="lazy" />
                                                    </div>
                                                    <div className="hot-page2-hom-pre-2">
                                                        <h5>Where can I get some?</h5>
                                                    </div>
                                                    <a href="blog-detail.html" className="fclick" />
                                                </li>
                                                <li>
                                                    <div className="hot-page2-hom-pre-1">
                                                        <img src="images/couples/4.jpg" alt="" loading="lazy" />
                                                    </div>
                                                    <div className="hot-page2-hom-pre-2">
                                                        <h5>The standard chunk of Lorem Ipsum</h5>
                                                    </div>
                                                    <a href="blog-detail.html" className="fclick" />
                                                </li>
                                            </ul>
                                        </div>
                                        {/*TOP POSTS*/}
                                        {/* SUBSCRIBE START*/}
                                        <div className="blog-subsc">
                                            <div className="ud-rhs-poin1">
                                                <img
                                                    src="https://cdn-icons-png.flaticon.com/512/6349/6349282.png"
                                                    alt=""
                                                    loading="lazy"
                                                />
                                                <h5>
                                                    Subscribe <b>Newsletter</b>
                                                </h5>
                                            </div>
                                            <form
                                                name="news_newsletter_subscribe_form"
                                                id="news_newsletter_subscribe_form"
                                            >
                                                <ul>
                                                    <li>
                                                        <input
                                                            type="text"
                                                            name="news_newsletter_subscribe_name"
                                                            placeholder="Enter Email Id*"
                                                            className="form-control"
                                                            required=""
                                                        />
                                                    </li>
                                                    <li>
                                                        <input
                                                            type="submit"
                                                            id="news_newsletter_subscribe_submit"
                                                            name="news_newsletter_subscribe_submit"
                                                            className="form-control"
                                                        />
                                                    </li>
                                                </ul>
                                            </form>
                                        </div>
                                        {/* SUBSCRIBE END*/}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END */}



        </>
    )
}

export default Blog